import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgreementService {

  constructor(
    private http: HttpClient,
  ) { }

  v2_getAgreement(): Observable<APIAgreementModel> {
    return this.http.get('/api/v2/agreement').pipe(
      map((res: APIAgreementModel) => { return res })
    );
  }

  v3_getAgreement(): Observable<V3APIUserAgreement> {
    let authData = sessionStorage.getItem("auth")!
    let token = JSON.parse(authData).token

    return this.http.get("/api/v3/docs/user-agreement", {
      headers: { "Authorization": `Bearer ${token}` },
    }).pipe(map((resp: V3APIUserAgreement) => { return resp }));
  }

  v3_getPrivacyPolicy(): Observable<V3APIPrivacyPolicy> {
    let authData = sessionStorage.getItem("auth")!
    let token = JSON.parse(authData).token

    return this.http.get("/api/v3/docs/integrity-policy", {
      headers: { "Authorization": `Bearer ${token}` },
    }).pipe(map((resp: V3APIPrivacyPolicy) => { return resp }));
  }

  v3_getAcceptedAgreement(): Observable<V3APIAcceptedAgreement> {
    let authData = sessionStorage.getItem("auth")!
    let token = JSON.parse(authData).token

    return this.http.get("/api/v3/docs/user-agreement/accepted", {
      headers: { "Authorization": `Bearer ${token}` },
    }).pipe(map((resp: V3APIAcceptedAgreement) => { return resp }));
  }

  v3_acceptAgreement(id: string): Observable<any> {
    let authData = sessionStorage.getItem("auth")!
    let token = JSON.parse(authData).token

    return this.http.post(`api/v3/docs/user-agreement/accept/${id}`, null, {
      headers: { "Authorization": `Bearer ${token}` },
    });
  }

}

export class APIAgreementModel {
  id: number;
  heading: string;
  body: string;
  active: boolean;
}

export class V3APIUserAgreement {
  ID: string;
  SvHeading: string;
  SvBody: string;
  EnHeading: string;
  EnBody: string;
  Active: boolean;
  Created: string;
}

export class V3APIPrivacyPolicy {
  ID: string;
  SvHeading: string;
  SvBody: string;
  EnHeading: string;
  EnBody: string;
  Active: boolean;
  Created: string;
}

export class V3APIAcceptedAgreement {
  accepted_agreement: string;
}
